<!-- ADD CUSTOMER COMPONENT -->
<form [formGroup]="captureClientDetailsForm" class="add-customer">
  <div class="grid grid-gap-20 grid-4x m-t-20">
    <nz-form-item class="form-item">
      <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('clientTypeCd',CAPTURECLIENTDETAILSFORMNAME)"><span
          translate>{{genericSearchLabel.clientType[currentLanguage]}}</span>
      </nz-form-label>
      <nz-select id="clientTypeCd" class="form-value" formControlName="clientTypeCd" style="width: 100%" 
        (ngModelChange)="validationUtilService.validateCrossFieldDependencies(captureClientDetailsForm,CAPTURECLIENTDETAILSFORMNAME,'clientTypeCd',$event)">
        <nz-option *ngFor="let item of (lookup$['clientTypeCd'] | async) as occupationCd; trackBy:item?.lookupKey"
          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
      </nz-select>
      <nz-form-explain
        *ngIf="(captureClientDetailsForm.get('clientTypeCd').dirty || captureClientDetailsForm.get('clientTypeCd').touched) && captureClientDetailsForm.get('clientTypeCd').errors">
        <p style="color:red"
          *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('clientTypeCd'), CAPTURECLIENTDETAILSFORMNAME)">
          {{error.errorMessage || '' |translate}}</p>
      </nz-form-explain>
    </nz-form-item>
  </div>

  <div class="grid grid-gap-20 grid-4x">
    <ng-container *ngIf="captureClientDetailsForm && captureClientDetailsForm.get('clientTypeCd').value == 'PERSON'">
      <nz-form-item class="form-item">
        <nz-form-label nzFor="title" [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('title',CAPTURECLIENTDETAILSFORMNAME)">
          <span>{{genericSearchLabel.title[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="titleField" [nzSpan]="24">
          <nz-select nzShowSearch id="title" class="form-value" style="width: 100%" formControlName="title" (ngModelChange)="fieldOnChangeHandler('title')">
            <nz-option *ngFor="let item of (lookup$['titleCd'] | async) as titleCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('title').dirty || captureClientDetailsForm.get('title').touched) && captureClientDetailsForm.get('title').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('title'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('firstName',CAPTURECLIENTDETAILSFORMNAME  )"><span
            translate>{{genericSearchLabel.firstName[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="firstNameField" [nzSpan]="24">
          <input nz-input [maxlength]="appMetadataHandler.configDataJSON['AppConstants']['inputFieldDefaultMaxLength']" placeholder="{{'First Name' | translate}}" class="form-value" formControlName="firstName" (ngModelChange)="fieldOnChangeHandler('firstName')"/>
          <span>
            <p style="font-size: xx-small;">{{captureClientDetailsForm.get('firstName').value ? captureClientDetailsForm.get('firstName').value.length : 0}}/{{appMetadataHandler.configDataJSON['AppConstants']['inputFieldDefaultMaxLength']}}</p> 

            <nz-form-explain
              *ngIf="(captureClientDetailsForm.get('firstName').dirty || captureClientDetailsForm.get('firstName').touched) && captureClientDetailsForm.get('firstName').errors">
              <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('firstName'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
            </nz-form-explain>
          </span>
        </nz-form-control>

      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.middleName[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="middleNameField" [nzSpan]="24">
          <input nz-input [maxlength]="appMetadataHandler.configDataJSON['AppConstants']['inputFieldDefaultMaxLength']" placeholder="{{'Middle Name' | translate}}" class="form-value" formControlName="middleName" (ngModelChange)="fieldOnChangeHandler('middleName')"/>
          <span>
            <p style="font-size: xx-small;">{{captureClientDetailsForm.get('middleName').value ? captureClientDetailsForm.get('middleName').value.length : 0}}/{{appMetadataHandler.configDataJSON['AppConstants']['inputFieldDefaultMaxLength']}}</p> 
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('middleName').dirty || captureClientDetailsForm.get('middleName').touched) && captureClientDetailsForm.get('middleName').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('middleName'), CAPTURECLIENTDETAILSFORMNAME)">
                {{error.errorMessage || '' |translate}}</p>
            </nz-form-explain>
          </span>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('lastName',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.lastName[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="lastNameField" [nzSpan]="24">
          <input nz-input [maxlength]="appMetadataHandler.configDataJSON['AppConstants']['inputFieldDefaultMaxLength']" placeholder="{{'Last Name' | translate}}" class="form-value" formControlName="lastName" (ngModelChange)="fieldOnChangeHandler('lastName')"/>
          <span>
            <p style="font-size: xx-small;">{{captureClientDetailsForm.get('lastName').value ? captureClientDetailsForm.get('lastName').value.length : 0}}/{{appMetadataHandler.configDataJSON['AppConstants']['inputFieldDefaultMaxLength']}}</p> 
            <nz-form-explain
              *ngIf="(captureClientDetailsForm.get('lastName').dirty || captureClientDetailsForm.get('lastName').touched) && captureClientDetailsForm.get('lastName').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('lastName'), CAPTURECLIENTDETAILSFORMNAME)">
                {{error.errorMessage || '' |translate}}</p>
            </nz-form-explain>
          </span>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label nzFor="gender" [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('gender',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.gender[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="genderField" [nzSpan]="24">
          <nz-select nzShowSearch id="gender" formControlName="gender" style="width: 100%" (ngModelChange)="fieldOnChangeHandler('gender')">
            <nz-option *ngFor="let item of (lookup$['genderCd'] | async) as genderCdCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <!--  -->
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('gender').dirty || captureClientDetailsForm.get('gender').touched) && captureClientDetailsForm.get('gender').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('gender'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('dateOfBirth',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.dateOfBirth[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="dobField" [nzSpan]="24">
          <nz-date-picker id="dateOfBirth" formControlName="dateOfBirth" style="width:100%"
            [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" (ngModelChange)="fieldOnChangeHandler('dateOfBirth')"></nz-date-picker>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('dateOfBirth').dirty || captureClientDetailsForm.get('dateOfBirth').touched) && captureClientDetailsForm.get('dateOfBirth').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('dateOfBirth'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>

      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('countryOfBirthCd',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.countryOfBirthCd[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="countryOfBirthCdField" [nzSpan]="24">
          <nz-select nzShowSearch style="width: 100%" formControlName="countryOfBirthCd" (ngModelChange)="fieldOnChangeHandler('countryOfBirthCd')">
            <nz-option
              *ngFor="let item of (lookup$['countryCd'] | async) as countryOfBirthCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('countryOfBirthCd').dirty || captureClientDetailsForm.get('countryOfBirthCd').touched) && captureClientDetailsForm.get('countryOfBirthCd').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('countryOfBirthCd'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>

        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('nationality',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.nationality[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="nationalityField" [nzSpan]="24">
          <!-- <input nz-input placeholder="{{'Nationality' | translate}}" formControlName="nationality" /> -->
          <nz-select nzShowSearch style="width: 100%" formControlName="nationality" (ngModelChange)="fieldOnChangeHandler('nationality')">
            <nz-option
              *ngFor="let item of (lookup$['citizenshipCd'] | async) as nationalityLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('nationality').dirty || captureClientDetailsForm.get('nationality').touched) && captureClientDetailsForm.get('nationality').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('nationality'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>

        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('maritalStatusCd',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.maritalStatusCd[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="maritalStatusField" [nzSpan]="24">
          <nz-select nzShowSearch id="maritalStatusCd" class="form-value" formControlName="maritalStatusCd" (ngModelChange)="fieldOnChangeHandler('maritalStatusCd')" style="width: 100%">
            <nz-option
            *ngFor="let item of (lookup$['maritalStatusCd'] | async) as maritalStatusLookup; trackBy:item?.lookupKey"
            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
            <nz-form-explain
          *ngIf="(captureClientDetailsForm.get('maritalStatusCd').dirty || captureClientDetailsForm.get('maritalStatusCd').touched) && captureClientDetailsForm.get('maritalStatusCd').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('maritalStatusCd'), CAPTURECLIENTDETAILSFORMNAME)">
            {{error.errorMessage || '' |translate}}</p>
        </nz-form-explain>

        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('occupationCategoryCd',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.occupationCategory[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="occupationCategoryField" [nzSpan]="24">
          <nz-select nzShowSearch id="occupationCategoryCd" class="form-value" formControlName="occupationCategoryCd" style="width: 100%" (ngModelChange)="fieldOnChangeHandler('occupationCategoryCd')">
          <nz-option *ngFor="let item of categoryKeys; trackBy:item"
            [nzLabel]="item" [nzValue]="item"></nz-option>
          </nz-select>
          <nz-form-explain
          *ngIf="(captureClientDetailsForm.get('occupationCategoryCd').dirty || captureClientDetailsForm.get('occupationCategoryCd').touched) && captureClientDetailsForm.get('occupationCategoryCd').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('occupationCategoryCd'), CAPTURECLIENTDETAILSFORMNAME)">
            {{error.errorMessage || '' | translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item" *ngIf="!isOtherOccupationSelected">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('occupationCd',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.occupation[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="occupationField" [nzSpan]="24">
          <nz-select nzShowSearch id="occupationCd" class="form-value" formControlName="occupationCd" style="width: 100%" (ngModelChange)="fieldOnChangeHandler('occupationCd')">
          <nz-option *ngFor="let item of occupationLookups.selectedOccupations; trackBy:item"
            [nzLabel]="item" [nzValue]="item"></nz-option>
          </nz-select>
          <nz-form-explain
          *ngIf="(captureClientDetailsForm.get('occupationCd').dirty || captureClientDetailsForm.get('occupationCd').touched) && captureClientDetailsForm.get('occupationCd').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('occupationCd'), CAPTURECLIENTDETAILSFORMNAME)">
            {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item" *ngIf="isOtherOccupationSelected">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('occupationCd',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.occupation[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="occupationField" [nzSpan]="24">
          <div style="display: flex; align-items: center;">
            <input nz-input placeholder="Enter Occupation" class="form-value" formControlName="occupationCd" (ngModelChange)="fieldOnChangeHandler('occupationCd')" style="flex: 1; margin-right: 8px;"/>
            <button nz-button nzType="default" nzSize="small" (click)="handleOtherFieldCancel()">x</button>
          </div>
          <nz-form-explain
          *ngIf="(captureClientDetailsForm.get('occupationCd').dirty || captureClientDetailsForm.get('occupationCd').touched) && captureClientDetailsForm.get('occupationCd').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('occupationCd'), CAPTURECLIENTDETAILSFORMNAME)">
            {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('occupationClassCd',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.occupationClass[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="occupationClassField" [nzSpan]="24">
          <input nz-input class="form-value" formControlName="occupationClassCd" style="flex: 1; margin-right: 8px;" (ngModelChange)="fieldOnChangeHandler('occupationClassCd')"/>
          <nz-form-explain
          *ngIf="(captureClientDetailsForm.get('occupationClassCd').dirty || captureClientDetailsForm.get('occupationClassCd').touched) && captureClientDetailsForm.get('occupationClassCd').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('occupationClassCd'), CAPTURECLIENTDETAILSFORMNAME)">
            {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
       
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('educationTypeCd',CAPTURECLIENTDETAILSFORMNAME)"><span translate>{{genericSearchLabel.highestQualification[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="educationTypeField" [nzSpan]="24">
          <nz-select nzShowSearch id="educationTypeCd" class="form-value" formControlName="educationTypeCd" style="width: 100%" (ngModelChange)="fieldOnChangeHandler('educationTypeCd')">
            <nz-option *ngFor="let item of (lookup$['educationCd'] | async) as educationLookup; trackBy:item?.lookupKey"
            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
        <nz-form-explain
          *ngIf="(captureClientDetailsForm.get('educationTypeCd').dirty || captureClientDetailsForm.get('educationTypeCd').touched) && captureClientDetailsForm.get('educationTypeCd').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('educationTypeCd'), CAPTURECLIENTDETAILSFORMNAME)">
            {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('sourceOfIncome',CAPTURECLIENTDETAILSFORMNAME)"><span translate>{{genericSearchLabel.sourceOfIncome[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="sourceOfIncomeField" [nzSpan]="24">
          <!-- <input nz-input placeholder="{{'Nationality' | translate}}" formControlName="nationality" /> -->
          <nz-select nzShowSearch style="width: 100%" class="form-value" formControlName="sourceOfIncome"  (ngModelChange)="fieldOnChangeHandler('sourceOfIncome')">
            <nz-option
              *ngFor="let item of (lookup$['sourceOfIncomeCd'] | async) as sourceOfIncomeLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('sourceOfIncome').dirty || captureClientDetailsForm.get('sourceOfIncome').touched) && captureClientDetailsForm.get('sourceOfIncome').errors">
            <p style="color:rgb(47, 37, 37)"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('sourceOfIncome'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.incomeRange[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="incomeRangeField" [nzSpan]="24">
          <!-- <nz-select nzShowSearch style="width: 100%" formControlName="incomeRange" (ngModelChange)="fieldOnChangeHandler('incomeRange')">
            <nz-option
              *ngFor="let item of (lookup$['yearlyIncomeRangeCd'] | async) as incomeRangeLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select> -->

          <input type="text" placeholder="{{'Annual Income' | translate}}" nz-input formControlName="incomeRange" 
          oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');" (ngModelChange)="fieldOnChangeHandler('incomeRange')"/>

          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('incomeRange').dirty || captureClientDetailsForm.get('incomeRange').touched) && captureClientDetailsForm.get('incomeRange').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('incomeRange'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>
           
      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.assetsAmt[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="incomeRangeField" [nzSpan]="24">
          <input type="text" placeholder="{{'Assets' | translate}}" nz-input formControlName="assetsAmt"
            oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');"
            (ngModelChange)="fieldOnChangeHandler('assetsAmt')" />
      
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('assetsAmt').dirty || captureClientDetailsForm.get('assetsAmt').touched) && captureClientDetailsForm.get('assetsAmt').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('assetsAmt'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.liabilitiesAmt[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="incomeRangeField" [nzSpan]="24">
          <input type="text" placeholder="{{'Liabilities' | translate}}" nz-input formControlName="liabilitiesAmt"
            oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');"
            (ngModelChange)="fieldOnChangeHandler('liabilitiesAmt')" />

          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('liabilitiesAmt').dirty || captureClientDetailsForm.get('liabilitiesAmt').touched) && captureClientDetailsForm.get('liabilitiesAmt').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('liabilitiesAmt'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.netWorthAmt[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="incomeRangeField" [nzSpan]="24">
          <input type="text" placeholder="{{'Net Worth' | translate}}" nz-input formControlName="netWorthAmt"
            oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');"
            (ngModelChange)="fieldOnChangeHandler('netWorthAmt')" />
      
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('netWorthAmt').dirty || captureClientDetailsForm.get('netWorthAmt').touched) && captureClientDetailsForm.get('netWorthAmt').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('netWorthAmt'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item" >
        <nz-form-label [nzSpan]="24" nzRequired nzFor="weight"><span translate>{{genericSearchLabel.weight[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="weightField" [nzSpan]="24" nzErrorTip="The input is not valid weight">
          <!-- <input nz-input placeholder="Weight" formControlName="weight"/> -->
          <!-- <nz-input-number formControlName="weight" nzPlaceHolder ="Weight" [nzMin]="1" [nzMax]="700" [nzStep]="1" style="width:100%;"></nz-input-number>  -->
          <input  type="text" placeholder="{{'Weight' | translate}}" nz-input formControlName="weight" 
          oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');" (ngModelChange)="fieldOnChangeHandler('weight')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('weight').dirty || captureClientDetailsForm.get('weight').touched) && captureClientDetailsForm.get('weight').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('weight'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item" >
        <nz-form-label [nzSpan]="24" nzRequired nzFor="height"><span translate>{{genericSearchLabel.height[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="heightField" [nzSpan]="24">
          <!-- <input nz-input placeholder="Height" formControlName="height" /> -->
          <!-- <nz-input-number formControlName="height" nzPlaceHolder ="Height" [nzMin]="1" [nzMax]="300" [nzStep]="1" style="width:100%;" [nzRequired]="isRequired('height')"></nz-input-number> -->
          <input type="text" placeholder="{{'Height' | translate}}" nz-input class="form-value" formControlName="height"
          oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');"  (ngModelChange)="fieldOnChangeHandler('height')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('height').dirty || captureClientDetailsForm.get('height').touched) && captureClientDetailsForm.get('height').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('height'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item" >
        <nz-form-label [nzSpan]="24" nzRequired nzFor="bmi"><span translate>{{genericSearchLabel.bmi[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="bmi" [nzSpan]="24">
          <input type="text" placeholder="{{'BMI' | translate}}" nz-input class="form-value" formControlName="bmi"
          oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');"  (ngModelChange)="fieldOnChangeHandler('bmi')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('bmi').dirty || captureClientDetailsForm.get('bmi').touched) && captureClientDetailsForm.get('bmi').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('bmi'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('haveCKYCNumber',CAPTURECLIENTDETAILSFORMNAME)"><span translate>{{genericSearchLabel.haveCKYCNumber[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="haveCKYCNumberField" [nzSpan]="24">
          <nz-select nzShowSearch style="width: 100%" class="form-value" formControlName="haveCKYCNumber" 
            (ngModelChange)="validationUtilService.validateCrossFieldDependencies(captureClientDetailsForm,CAPTURECLIENTDETAILSFORMNAME,'haveCKYCNumber',$event)">
            <nz-option nzLabel="Yes" nzValue = "YES"></nz-option>
            <nz-option nzLabel="No" nzValue = "NO"></nz-option>
          </nz-select>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('haveCKYCNumber').dirty || captureClientDetailsForm.get('haveCKYCNumber').touched) && captureClientDetailsForm.get('haveCKYCNumber').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('haveCKYCNumber'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="form-item">
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('CKYCNumber',CAPTURECLIENTDETAILSFORMNAME)"><span translate>{{genericSearchLabel.CKYCNumber[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="CKYCNumberField" [nzSpan]="24">
          <input nz-input placeholder="CKYC Number" class="form-value" formControlName="CKYCNumber" (ngModelChange)="fieldOnChangeHandler('CKYCNumber')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('CKYCNumber').dirty || captureClientDetailsForm.get('CKYCNumber').touched) && captureClientDetailsForm.get('CKYCNumber').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('CKYCNumber'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>
      
      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('noOfChildren',CAPTURECLIENTDETAILSFORMNAME)">
          <span translate>{{genericSearchLabel.noOfChildren[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="noOfChildrenField" [nzSpan]="24">
          <input nz-input type="number"  formControlName="noOfChildren" min="0" [nzStep]="1" style="width:100%;" (ngModelChange)="fieldOnChangeHandler('noOfChildren')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('noOfChildren').dirty || captureClientDetailsForm.get('noOfChildren').touched) && captureClientDetailsForm.get('noOfChildren').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('noOfChildren'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>
    </ng-container>

    <ng-container
      *ngIf="captureClientDetailsForm && (captureClientDetailsForm.get('clientTypeCd').value == 'ORGANISATION' ||
       captureClientDetailsForm.get('clientTypeCd').value == 'ORGANIZATION')">
      <!-- companyName -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('companyName',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.companyName[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="{{'Company Name' | translate}}" 
            formControlName="companyName" 
            (ngModelChange)="fieldOnChangeHandler('companyName')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('companyName').dirty || captureClientDetailsForm.get('companyName').touched) 
              && captureClientDetailsForm.get('companyName').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('companyName'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>

      </nz-form-item>

      <!-- contactPersonName -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('contactPersonName',CAPTURECLIENTDETAILSFORMNAME)"><span
            translate>{{genericSearchLabel.contactPerson[currentLanguage]}}
            Name</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="{{'Contact Person Name' | translate}}" formControlName="contactPersonName" (ngModelChange)="fieldOnChangeHandler('contactPersonName')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('contactPersonName').dirty || captureClientDetailsForm.get('contactPersonName').touched) && captureClientDetailsForm.get('contactPersonName').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('contactPersonName'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="validationUtilService.isRequired('gstNumber',CAPTURECLIENTDETAILSFORMNAME)"><span translate>{{genericSearchLabel.gstNumber[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="GST Number" formControlName="gstNumber" />
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('gstNumber').dirty || captureClientDetailsForm.get('gstNumber').touched) && captureClientDetailsForm.get('gstNumber').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('gstNumber'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

    </ng-container>
    <!--TODO take review from Ninad  -->
    <input type="hidden" formControlName="clientid">
    <input type="hidden" formControlName="clientGuid">
    <input type="hidden" formControlName="statusCd">
    <input type="hidden" formControlName="clientNum">
    <input type="hidden" formControlName="personId">
    <input type="hidden" formControlName="personGuid">

  </div>

  <div class="heading-tab">
    <h3 class="heading">
      <i nz-icon nzType="file-unknown" class="m-r-5"></i> <span translate>Contact Details</span></h3>
  </div>

  <div class="flexie-auto-grid">

    <!-- Email -->
    <div class="flex-self-vert-start">
      <h4>
        <i nz-icon nzType="mail" nzTheme="outline" class="m-r-5"></i> <span translate>Email</span></h4>
      <ui-multirow-basic (componentOutput)="fetchEmailList($event)" type="email"
        [inputDataForEdit]="inputClientCaptureEmailDetailsList"></ui-multirow-basic>
        <span>
          <label id="emailCheckbox" nz-checkbox formControlName="copyOfEmail">Do you wish to receive the copy of the policy document by Email /
            WhatsApp / Any other electronic mode</label>
        </span>
    </div>

    <!-- Mobile -->
    <div class="flex-self-vert-start">
      <h4>
        <i nz-icon nzType="mobile" nzTheme="outline" class="m-r-5"></i> <span translate>Mobile</span></h4>
      <ui-multirow-basic (componentOutput)="fetchphoneList($event)" type="phone"
        [inputDataForEdit]="inputClientCapturePhoneDetailsList"></ui-multirow-basic>
      <span>
        <label id="phoneCheckbox" nz-checkbox formControlName="contactByMobile">In case of any Offer, would you prefer to be contacted by Mobile Number</label>
      </span>
    </div>
  </div>

  <div>
    <ui-address-ind (componentOutput)="fetchAddressList($event)" [inputDataForEdit]="inputClientCaptureAddressDetailsList"></ui-address-ind>
  </div>
  <app-identity-capture (componentOutput)="fetchIdentityList($event)" [inputDataForEdit]="inputClientCaptureIdentityDetailsList"></app-identity-capture>
</form>

<div class="footer-actions-bar">
  <div>
    <!-- Left -->
  </div>
  <div>
    <!-- Right -->
    <button nz-button class="mr-20" (click)="cancelTask()">
      <span translate>Cancel</span>
    </button>
    <button nz-button [nzType]="'primary'" (click)="transformClient()"><span translate>Save</span></button>
  </div>
</div>
<!-- /add-customer-->